import React from 'react';
import { createRoot } from 'react-dom/client';

import FinanceFreeReportContainer from './containers/FinanceFreeReport';

const rootNode = document.getElementById('finance-free-report-root');

const { companies_list, company_ticker, sitekey, shared_by_report_id, recommended_companies } =
  JSON.parse(rootNode.dataset.reportData);

const companies_options = [
  {
    label: 'Select a Company',
    value: undefined,
    itemClass: 'd-none',
  },
  ...companies_list.map(({ company_name, ticker }) => ({
    label: `${company_name} (${ticker})`,
    value: ticker,
  })),
];

const companies_tikers = companies_list.map(({ ticker }) => ticker);

const isTickerValid = (ticker) => !!ticker && new Set(companies_tikers).has(ticker);

const initial_ticker = isTickerValid(company_ticker) ? company_ticker : undefined;

const FinanceFreeReport = () => (
  <FinanceFreeReportContainer
    initialData={{
      sitekey,
      initial_ticker,
      companies_list,
      recommended_companies,
      companies_options,
      shared_by_report_id,
    }}
  />
);

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<FinanceFreeReport />);
});
